import { Injectable } from '@angular/core';
import { Util } from '../utils/utils.module';
import { Observable, of } from 'rxjs';

export enum AdminTabs {
  GENERAL = 'GENERAL',
  LOOKUPS = 'LOOKUPS',
  TILES = 'TILES',
  FOOTER = 'FOOTER',
  GROUPS = 'GROUPS',
  SYSTEM_PARAMS = 'SYSTEM_PARAMS',
  PEOPLE = 'PEOPLE'
}

const AdminUtilities = {
  LOOKUPS: 'EDIT_VTS',
  PEOPLE: 'MANAGE_GROUPS',
  GROUPS: 'MANAGE_GROUPS',
  SYSTEM_PARAMS: 'EDIT_LIBPARMS'

};

export const AdminFeatures = {
  APP_FORMS_CONFIG: 'APP_FORMS_CONFIG',
};

export const AdminRequestKeys = {
  ADD_GROUP_SEARCHFORMS: '%ADD_GROUP_SEARCHFORMS',
  REMOVE_GROUP_SEARCHFORMS: '%REMOVE_GROUP_SEARCHFORMS',
  ADD_GROUP_APPFORMS: '%ADD_GROUP_APPFORMS',
  REMOVE_GROUP_APPFORMS: '%REMOVE_GROUP_APPFORMS'
};

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor() { }

  public canUserAccessAdminMaintenance(): boolean {
    return Util.Device.isWebLook() && this.canUserAccessAnyAdminTab();
  }

  public canUserAccessAnyAdminTab(library?: any): boolean {
    return this.canUserManageAdminFeatures(['GENERAL', 'TILES', 'FOOTER'])
      || this.canUserManageLookups(library)
      || this.canUserManageUsersAndGroups(library)
      || this.canUserManageSystemParams(library);
  }

  public canUserManageAdminFeature(feature: string): boolean {
    return Util.RestAPI.isAdminFeatureEnabled(feature) && Util.RestAPI.isAdminByGroup();
  }

  public canUserManageAdminFeatures(features: string[]): boolean {
    return Util.RestAPI.anyAdminFeatureEnabled(features) && Util.RestAPI.isAdminByGroup();
  }

  public canUserManageLookups(library?: any): boolean {
    return Util.RestAPI.isAdminFeatureEnabled('LOOKUPS') && this.canUserManageAdminTabForGivenLibrary(library, AdminTabs.LOOKUPS);
  }
  
  public canUserManageUsersAndGroups(library?: any): boolean {
    return Util.RestAPI.isAdminFeatureEnabled('MANAGE_GROUPS') && (this.canUserManageAdminTabForGivenLibrary(library, AdminTabs.GROUPS) || Util.RestAPI.isAdminByGroup());
  }

  public canUserManageSystemParams(library?: any): boolean {
    return Util.RestAPI.isAdminFeatureEnabled('SYSTEM_PARAMS') && (this.canUserManageAdminTabForGivenLibrary(library, AdminTabs.SYSTEM_PARAMS) || Util.RestAPI.isAdminByGroup());
  }

  public canUserManageAppFormsConfig(): boolean {
    return this.canUserManageAdminFeature(AdminFeatures.APP_FORMS_CONFIG);
  }

  public canUserManageAdminTabForGivenLibrary(library: any, tabId: any): boolean {
    if (!!library && library?.LIBRARY_NAME?.toUpperCase() !== Util.RestAPI.getPrimaryLibrary()?.toUpperCase()) {
      return !!library.EFFECTIVE_RIGHTS && library.EFFECTIVE_RIGHTS[AdminUtilities[tabId]] === 'Y';
    } else {
      return Util.RestAPI.getUserRightFor(AdminUtilities[tabId]);
    }
  }


  public canUserManagePeople(library: any): boolean {
    return Util.RestAPI.isAdminFeatureEnabled('PEOPLE') && this.canUserManageAdminTabForGivenLibrary(library, AdminTabs.PEOPLE);
  }

  public getGroupLevelPermissions(groupId: string, library: string): Observable<any> {
    const libraryObj = Util.RestAPI.getLibraryByName(library);
    if (!!groupId && (this.canUserManageUsersAndGroups(libraryObj) || this.canUserManageSystemParams(libraryObj))) {
      const queryArgs = '?library=' + (library ?? Util.RestAPI.getPrimaryLibrary());
      return Util.RestAPI.get('admin', 'groups/' + groupId, queryArgs);
    }
    return of({});
  }

  public getSystemParams(library): Observable<any> {
    if (this.canUserManageSystemParams(library)) {
      const queryArgs = '?library=' + (library['LIBRARY_NAME'] ?? Util.RestAPI.getPrimaryLibrary());
      return Util.RestAPI.get('admin', 'system_params', queryArgs);
    }
    return of({});
  }
}
